import styled from "styled-components";

const StyledFieldset = styled.fieldset`
		position: relative;
		width: 100%;
		border-radius: 8px;
		border: 1px solid var(--border-color);
		padding: 10px;
		margin-bottom: 1rem;
`;
	
export default StyledFieldset;
